import type { JSX } from "react";
interface Props {
  headerChildren?: () => JSX.Element
  children: React.ReactNode
}

export const PageScrollWrapper: React.FC<Props> = ({ children, headerChildren }) => {
  return (
    <>
      {headerChildren && <header>{headerChildren()}</header>}
      <div className="flex-shrink-1 transition-width transition-height flex h-full flex-grow-0 flex-col overflow-scroll duration-200 ease-out">
        <div
          className="flex-grow-1 flex flex-col items-center overflow-y-auto overflow-x-hidden"
          id="page-scroll-wrapper">
          <div className="flex-grow-1 relative flex w-full flex-col">{children}</div>
        </div>
      </div>
    </>
  )
}
